{
  "form": {
    "input_placeholder": "Ajouter une tâche…",
    "parseWithAi_aria": "Analyser la tâche avec l'IA",
    "parseWithAi_title": "Mettre en forme et définir la priorité avec l'IA",
    "priorityLabel_aria": "Priorité de la tâche",
    "add": "Ajouter",
    "signInForAi": "Connectez-vous pour utiliser les fonctions IA.",
    "aiUnavailable": "IA indisponible. Réessayez.",
    "saveTo": "Enregistrer dans",
    "saveTo_aria": "Enregistrer dans {{list}}",
    "saveToSynced_aria": "Enregistrer dans {{list}}, {{provider}}",
    "addedTo": "Ajouté à {{list}}",
    "addedToSynced": "Ajouté à {{list}} · {{provider}}",
    "show": "Afficher"
  },
  "priority": {
    "Critical": "Critique",
    "High": "Haute",
    "Medium": "Moyenne",
    "Low": "Basse"
  },
  "item": {
    "edit_aria": "Modifier la tâche",
    "delete_aria": "Supprimer la tâche",
    "addStep": "Ajouter une étape",
    "addStep_placeholder": "Ajouter une étape…",
    "addStep_aria": "Ajouter une étape à {{task}}",
    "steps_group_aria": "Étapes de {{task}}",
    "steps_progress_aria": "{{done}} sur {{count}} étapes terminées",
    "completeSteps_aria": "{{task}}. Termine aussi {{count}} étapes ouvertes"
  },
  "list": {
    "title": "Tâches",
    "newListFallback": "Nouvelle liste",
    "completedMeta": "{{completed}} sur {{total}} terminées",
    "deleteConfirm": "Supprimer « {{name}} » ?",
    "rename_title": "Renommer",
    "deleteList_title": "Supprimer la liste",
    "newListName_placeholder": "Nom de la liste…",
    "newList": "Nouvelle liste",
    "done": "Terminé",
    "emptyTitle": "Aucune tâche pour l'instant",
    "emptySubtitle": "Ajoutez-en une ci-dessous pour commencer.",
    "noFilterMatch": "Aucune tâche ne correspond à ce filtre.",
    "createIn": "Créer dans",
    "inDestination": "dans {{destination}}",
    "createIn_aria": "Créer dans {{destination}}",
    "createInAccount_aria": "Créer dans {{destination}}, {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "Création dans {{destination}}…",
    "createFailed": "Impossible de créer « {{name}} » dans {{destination}}.",
    "createLimit": "{{destination}} a atteint sa limite de listes.",
    "keepInRhemn": "Garder dans Rhemn"
  },
  "filter": {
    "label": "Filtrer",
    "all": "Toutes"
  },
  "voice": {
    "mic_aria": "Ajouter des tâches à la voix",
    "mic_title": "Dites vos tâches — triées par priorité et moment",
    "stop_aria": "Arrêter et trier les tâches",
    "recording": "Enregistrement",
    "sorting": "Tri de vos tâches…",
    "stripTitle": "Tâches entendues",
    "stripCount": "{{checked}} sur {{total}}",
    "discard": "Ignorer",
    "addN": "Ajouter {{count}}",
    "addZero": "Ajouter",
    "adding": "Ajout…",
    "parseFallback": "Tri impossible — vos mots sont dans le champ.",
    "nothingHeard": "Rien entendu — réessayez.",
    "micDenied": "Micro bloqué — autorisez-le dans les réglages.",
    "gateBody": "Dites vos tâches — triées par priorité et bloc de prière. Inclus avec Pro.",
    "listen_aria": "Écoute — dites vos tâches"
  }
}
